import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import { WaveLoading } from 'react-loadingg'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import { write, utils } from 'xlsx'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
class ProductStoreList extends React.Component {
  state = {
    ProductStoreList: [],
    product_image_excel_file: '',
    excelFile: '',
    productImages: [],
    images: [],
    isLoading: false,
    excelUploadErrors: [],
    isPaydoStore: false,
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  }
  componentDidMount() {
    this.ProductStoreList()
  }
  ProductStoreList = async () => {
    this.setState({
      isLoading: true,
      ProductStoreList: [],
    })

    await axios
      .get(Constant.getAPI() + `/store/list-products/${this.props.match.params.storeDetail_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            ProductStoreList: res.data.data?.result,
            isPaydoStore: res.data.data?.isPaydoStore,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  submitExcel = async () => {
    let storeProductId = this.props.match.params.storeDetail_id

    if (storeProductId && this.state.excelFile) {
      this.setState({ isLoading: true })
      localStorage.setItem('isLoading', true)
      const data = {
        file: this.state.excelFile,
        storeProductId,
      }

      await axios
        .post(Constant.getAPI() + '/admin/product-list-sample-excel-import', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState(
            {
              isLoading: false,
              excelFile: '',
              excelUploadErrors: res?.data?.data?.error || [],
            },
            () => {
              this.image_excel.value = null
            }
          )
          Swal.fire({
            title: 'Store Details Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.ProductStoreList()
        })
        .catch((err) => {
          this.setState({ isLoading: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          localStorage.setItem('isLoading', false)
        })
    }
  }

  handleStatusChange = async (id, isActive, nameData) => {
    if (isActive === 'is_active') {
      var data = {
        itemId: id,
        is_active: nameData.target.checked,
      }
    } else {
      data = {
        itemId: id,
        is_stock_enable: nameData.target.checked,
      }
    }

    await axios
      .post(Constant.getAPI() + '/store/update-store-item', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.ProductStoreList()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCategoryListExcelFile = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/get-category-list-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  downloadSampleProductListExcelFile = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/product-list-sample-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleExcelChange = (e) => {
    const reader = new FileReader()
    const name = e.target.name
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0]
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState({
          [name]: reader.result,
        })
      }
    } else {
      this.setState({
        [name]: '',
      })
    }
  }

  syncProducts = async () => {
    this.setState({
      isLoading: true,
      ProductStoreList: [],
    })
    await this.getIroverProductsCategories()
    this.setState({
      isLoading: false,
    })
  }

  getIroverProducts = async () => {
    let storeProductId = this.props.match.params.storeDetail_id
    await axios
      .get(Constant.getAPI() + `/store/sync-irover-products?storeId=${storeProductId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async () => {
        await this.ProductStoreList()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getIroverProductsCategories = async () => {
    let storeProductId = this.props.match.params.storeDetail_id
    await axios
      .get(Constant.getAPI() + `/store/sync-irover-product-categories?storeId=${storeProductId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async () => {
        await this.getIroverProducts()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  deleteProduct = (id) => {
    this.setState({ isLoading: true })
    axios
      .delete(Constant.getAPI() + `/store/delete-store-item/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Product Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.ProductStoreList()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.ProductStoreList()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.ProductStoreList()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    let columns = [
      {
        name: 'shop_item_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (shop_item_img) => {
            return (
              <img
                src={
                  shop_item_img !== undefined && shop_item_img !== null && shop_item_img !== {}
                    ? shop_item_img
                    : './assets/images/icon.png'
                }
                className="img-fluid img-40"
                alt="tbl"
              />
            )
          },
        },
      },
      {
        name: 'item_name_en',
        label: 'Item Name: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_name_ar',
        label: 'Item Name: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_amount',
        label: 'Item Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'store_item_category_links',
        label: 'Categories',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return data.map((item) => (
              <>
                <span>{item?.category?.nameEn}</span>
                <br />
              </>
            ))
          },
        },
      },
      {
        name: 'stock_limit',
        label: 'Stock Limit',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_desc_en',
        label: 'Item Description: English',
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (item_desc_en) => {
            return <div>{item_desc_en}</div>
          },
        },
      },
      {
        name: 'item_desc_ar',
        label: 'Item Description: Arabic',
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (item_desc_ar) => {
            return <div>{item_desc_ar}</div>
          },
        },
      },
      {
        name: 'is_stock_enable',
        label: 'Stock Enable',
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (is_stock_enable, tableMeta) => {
            return (
              <Toggle
                id={'Owner_active_status_' + tableMeta.rowData[tableMeta.rowData?.length - 1]}
                checked={is_stock_enable === true ? true : false}
                value={is_stock_enable}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[tableMeta.rowData?.length - 1], 'is_stock_enable')}
              />
            )
          },
        },
      },
      {
        name: 'item_for',
        label: 'Item For',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'Owner_active_status_' + tableMeta.rowData[tableMeta.rowData?.length - 1]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[tableMeta.rowData?.length - 1], 'is_active')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Product Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <Link
                to={`/storeProductsImage/` + id}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title="View Boat Details "
              >
                <i className="f-22 icofont icofont-eye text-dark"></i>
              </Link>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        display: false,
        options: {
          filter: true,
          sort: true,
          display: this.state.isPaydoStore ? false : true,
          customBodyRender: (id) => {
            const userType = localStorage?.getItem('loged_In_role')
            return (
              <div className="d-flex justify-content-end align-items-center">
                {userType === 'store' ? (
                  <Link
                    to={`/product-details/add/${this.props.match.params.storeDetail_id}/` + id}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                ) : (
                  <>
                    <Link
                      to={`/product-details/add/${this.props.match.params.storeDetail_id}/` + id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Edit"
                    >
                      <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                    </Link>
                    <span
                      onClick={this.deleteProduct.bind(this, id)}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Delete"
                    >
                      <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                    </span>
                    <ActivitiesController refId={id}>Activities</ActivitiesController>
                  </>
                )}
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Store-items',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Store-items`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (!['Image', 'Action'].includes(columns[idx]?.label)) {
              temp[columns[idx].label] = v
            }
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()
        return false
      },
      search: true,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.ProductStoreList()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.ProductStoreList()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No details Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-4">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Product List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  {!this.state.isPaydoStore && (
                    <Link
                      to={`/product-details/add/${this.props.match.params.storeDetail_id}`}
                      className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger m-l-5"
                      data-modal="modal-13"
                    >
                      {' '}
                      <i className="icofont icofont-plus m-r-5"></i> Add Product Details
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="row">
                        {!this.state.isPaydoStore && (
                          <>
                            <div
                              className="col-md-12"
                              style={{ marginBottom: 20 }}
                            >
                              <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                                Upload Product List Excel File
                                <span style={{ fontSize: 12, color: 'red' }}>
                                  {' '}
                                  (Use only dropbox for shared link of images and format should be JPEG, JPG Or PNG)
                                </span>
                                <div
                                  onClick={this.downloadSampleProductListExcelFile}
                                  className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger m-l-5"
                                >
                                  <i className="icofont icofont-upload-alt"></i>
                                  Export Sample Product list file
                                </div>
                                <div
                                  onClick={this.getCategoryListExcelFile}
                                  className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger m-l-5"
                                >
                                  <i className="icofont icofont-upload-alt"></i>
                                  Export Categories For Product Item
                                </div>
                              </div>
                            </div>
                            <div className="col-2">Product List Excel File</div>
                            <div className="col-4">
                              <div className="form-group">
                                <div>
                                  <input
                                    type="file"
                                    id="excelFile"
                                    name="excelFile"
                                    accept=".xls,.xlsx"
                                    className="w-100"
                                    onChange={this.handleExcelChange}
                                    ref={(ref) => (this.image_excel = ref)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              {!this.state.isLoading && !!this.state.excelFile && (
                                <div
                                  onClick={this.submitExcel}
                                  className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                                >
                                  <i className="icofont icofont-upload-alt"></i>
                                  Upload Product List Excel file
                                </div>
                              )}
                              {!this.state.excelFile && (
                                <div className="btn btn-sm btn-disabled waves-light f-right">
                                  <i className="icofont icofont-upload-alt"></i>
                                  Upload Product List Excel file
                                </div>
                              )}
                              {this.state.isLoading && (
                                <div className="btn btn-sm waves-effect btn-grd-disabled f-right">Uploading...</div>
                              )}
                            </div>
                          </>
                        )}
                        <div className="col-12">
                          {!this.state.isLoading && this.state.isPaydoStore && (
                            <div
                              onClick={this.syncProducts}
                              className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                            >
                              {/* <i className="icofont-loop icofont-loop-alt"></i>    */}
                              Sync products
                            </div>
                          )}
                          {this.state.isLoading && (
                            <div className="btn btn-sm waves-effect btn-grd-disabled f-right">Loading...</div>
                          )}
                        </div>
                        <div className="col-12">
                          {this.state.excelUploadErrors.map((item) => (
                            <>
                              <span style={{ color: '#f00' }}>{item}</span>
                              <br />
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Product List'}
                          className="table-responsive"
                          data={this.state.ProductStoreList}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductStoreList
